/* globals window document Raven */

import React from 'react';
import { render } from 'react-dom';
import { combineReducers, createStore, applyMiddleware, compose } from 'redux';
import createSagaMiddleware from 'redux-saga';
import ga from 'react-ga';
import { AppContainer } from 'react-hot-loader';

import * as reducers from 'reducers';
import rootSaga from 'sagas';

import '../styles/main.scss';

import Root from './Root';

if (process.env.NODE_ENV === 'production') {
  Raven.config('https://bab57e993dfb4caa862204bafa2a9c6e@sentry.io/123737', {
    release: process.env.VERSION,
    environment: process.env.NODE_ENV,
    tags: {
      git_commit: process.env.COMMITHASH,
      git_branch: process.env.BRANCH,
    },
  }).install();
}

const initialState = window.__INITIAL_STATE__; // eslint-disable-line no-underscore-dangle

const reducer = combineReducers(reducers);
const sagaMiddleware = createSagaMiddleware();
const store = createStore(
  reducer,
  initialState,
  compose(applyMiddleware(
    sagaMiddleware),
    window.devToolsExtension ? window.devToolsExtension() : f => f,
  ),
);
sagaMiddleware.run(rootSaga);

ga.initialize(process.env.NODE_ENV === 'production' ? 'UA-77540585-1' : 'UA-XXXXXXXX-X');

function runApp() {
  render(
    <AppContainer>
      <Root store={store} locale={initialState.locale.language} />
    </AppContainer>,
    document.getElementById('app'),
  );

  if (module.hot) {
    module.hot.accept();

    console.error = (message) => { // eslint-disable-line no-console
      if (message && message.indexOf('You cannot change <Router routes>;') !== -1) {
        return; // eslint-disable-line no-useless-return
      }
    };
  }
}

if (!global.Intl) {
  require.ensure([
    'intl',
    'intl/locale-data/jsonp/en.js',
  ], function (require) { // eslint-disable-line prefer-arrow-callback
    require('intl');
    require('intl/locale-data/jsonp/en');

    runApp();
  });
} else {
  runApp();
}



// WEBPACK FOOTER //
// ./app/scripts/main.jsx